import { Logger } from '@main/utils/logger';
import type { ShowTeamListEventPublisher } from './show-teamlist.usecase';

export class ShowTeamListPublisher implements ShowTeamListEventPublisher {
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(): Promise<void> {
    this.logger.info('ShowTeamListPublisher:', {
      action: 'ShowTeamListPublisher',
    });
  }
}
